import React from 'react';
import CardOrder from '../CardOrder/CardOrder';
import CardCartConfirm from '../../components/CardCartConfirm/CardCartConfirm';
import { Grid } from '@material-ui/core';
import { Link } from 'react-router-dom';
const CardBlockOrder = ({...props}) => {
    let list = [];
    if(props.list !== undefined){
        list = props.list.orderDetails
    }
    // console.log(list)

    const renderCards = () => (
        list ?
        list.map((card,index) => (
            <CardOrder key={index} {...card} widthDetail="220" />
        )) : null
    )

    return (
        <>
        <div className="container" style={{ marginTop: 50 }}>
            <div className="row" id="topOrderDetail">
                <div className="col-md-2 text-left">
                    Mã đơn hàng
                </div>
                <div className="col-md-3 text-left" style={{ paddingLeft:45 }}>
                    Ngày đặt hàng
                </div>
                <div className="col-md-2 text-center">
                    Trạng thái
                </div>
                <div className="col-md-3 text-center">
                    Tổng tiền
                </div>
            </div>
            <hr className="divider" />
            <div style={{ display:'flex', flexDirection:'column' }}>
                {renderCards(props.list)}
            </div>
        </div>
        </>
    )
};

export default CardBlockOrder;